import AnimatedPage from "@/components/AnimatedPage";
import HeaderBox from "@/components/HeaderBox";
import HelmetMetaData from "@/components/HelmetMetaData";
import Unavailable from "@/components/Unavailable";
import ElectricityTile from "@/components/dashboard/ElectricityTile";
import BuyElectricityForm from "@/components/forms/BuyElectricityForm";
import AirtimeSkeleton from "@/components/skeletons/airtime-skeleton";
import { GetRequest } from "@/lib/http";
import { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

const BuyElectricity = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const user = useSelector((state) => state.user.user);
  const [data, setData] = useState(null);

  const electricBenef = useLocation().state;

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      amount: 0,
      savebeneficiary: false,
    },
  });

  async function getData() {
    const { err, data: apiData } = await GetRequest({
      url: "/api/electricity-details",
      setState: setLoading,
    });

    if (!err) {
      setData(apiData);

      if (electricBenef && apiData) {
        const gg = apiData.discos.findIndex(
          (value) =>
            value &&
            value.toLowerCase().includes(electricBenef.disco?.toLowerCase()),
        );

        setValue("disco", String(gg));
        setValue("type", electricBenef.meter_type);
        setValue("number", electricBenef.value);
      }
    } else {
      setError(err);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  if (!user.meta_data?.electricity_active) return <Unavailable />;

  // useEffect(() => {}, [electricBenef, metadata]);

  return (
    <AnimatedPage>
      <HelmetMetaData
        title="Pay Your Electricity Bill Online"
        description="Manage your electricity payments conveniently. Purchase your electricity bills quickly and securely to ensure uninterrupted service at home!"
      />

      <section className="p-3 sm:p-5">
        <div className="flex flex-col-reverse items-start justify-between md:flex-row">
          <HeaderBox
            title="Instant Electricity Bill Payment"
            subtext="Stay connected—manage your electricity payments with just a few clicks!"
          />

          <div>
            <h2 className="text-sm font-medium">
              <Link to="/dashboard" className="hover:underline">
                Dashboard
              </Link>

              <span className="px-2 text-xl font-thin">/</span>

              <span className="text-gray-400">Buy Electricity Bills</span>
            </h2>
          </div>
        </div>
        {loading ? (
          <AirtimeSkeleton />
        ) : error ? (
          <div className="text-center text-red-500">{error}</div>
        ) : (
          <>
            <ElectricityTile />
            <BuyElectricityForm
              metadata={data}
              isFetching={loading}
              register={register}
              control={control}
              watch={watch}
              errors={errors}
              setValue={setValue}
              reset={reset}
              handleSubmit={handleSubmit}
            />
          </>
        )}
      </section>
    </AnimatedPage>
  );
};

export default BuyElectricity;
